module.exports = require('./helpers/bundle-url').getBundleURL('15Vj6') + "btn_facebook.6fc3bc73.png";